<template>
  <div>
    <v-tabs
      :model-value="modelValue"
      class="tab-header-container"
      density="compact"
      fixed-tabs
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <v-tab
        v-for="(item, index) in tabs"
        :key="item"
        class="ma-1 text-body-3"
        :class="{ 'mr-0': index !== tabs.length - 1, 'ml-0': index > 0 }"
        :value="item"
        height="26"
        min-width="0"
        size="small"
        hide-slider
      >
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-window :model-value="modelValue">
      <slot />
    </v-tabs-window>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  tabs: {
    type: Array,
    required: true,
    default: () => [],
  },
});

defineEmits(['update:modelValue']);
</script>

<style scoped lang="less">
.tab-header-container {
  border-radius: 40px;
  border: 1px solid fade(@grey-900, 10%);

  &:deep(.v-tab) {
    &.v-btn {
      border-radius: 24px;
    }
  }

  &:deep(.v-tab--selected) {
    color: @text-brand;
    background-color: fade(@bg-brand-default, 10%);
  }
}
</style>
